import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{staticClass:"px-5 mt-2",staticStyle:{"height":"auto"},attrs:{"centered":"","timeout":3000,"color":_vm.snackColor},model:{value:(_vm.snack),callback:function ($$v) {_vm.snack=$$v},expression:"snack"}},[_c('span',{staticStyle:{"color":"black"}},[_vm._v(_vm._s(_vm.snackText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }